// ./navigation.ts
let navigateFn: ((path: string) => void) | null = null;

export const setNavigate = (fn: typeof navigateFn) => {
  navigateFn = fn;
};

export const navigateTo = (path: string) => {
  if (navigateFn) {
    navigateFn(path);
  }
};
